/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rules for advancing teams to a subsequent tournament
 * @export
 * @interface TournamentAdvancementRules
 */
export interface TournamentAdvancementRules {
    /**
     * Number of top teams that advance
     * @type {number}
     * @memberof TournamentAdvancementRules
     */
    top?: number;
    /**
     * ID of the tournament teams advance to
     * @type {string}
     * @memberof TournamentAdvancementRules
     */
    advanceTo?: string;
}

/**
 * Check if a given object implements the TournamentAdvancementRules interface.
 */
export function instanceOfTournamentAdvancementRules(value: object): value is TournamentAdvancementRules {
    return true;
}

export function TournamentAdvancementRulesFromJSON(json: any): TournamentAdvancementRules {
    return TournamentAdvancementRulesFromJSONTyped(json, false);
}

export function TournamentAdvancementRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentAdvancementRules {
    if (json == null) {
        return json;
    }
    return {
        
        'top': json['top'] == null ? undefined : json['top'],
        'advanceTo': json['advanceTo'] == null ? undefined : json['advanceTo'],
    };
}

export function TournamentAdvancementRulesToJSON(json: any): TournamentAdvancementRules {
    return TournamentAdvancementRulesToJSONTyped(json, false);
}

export function TournamentAdvancementRulesToJSONTyped(value?: TournamentAdvancementRules | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'top': value['top'],
        'advanceTo': value['advanceTo'],
    };
}

